module.exports = __webpack_public_path__ + "img/IMG_0079_L_WoodMatted_MockedUp.397bc05f.jpg";